(() => {
  if (window.famNavigationReady) return;
  window.famNavigationReady = true;
  const prefixes = ['fhh', 'fac', 'fam', 'fvw'];
  const cartSelector = prefixes.flatMap(p => [`#${p}CartDesktop`, `#${p}CartMobile`]).join(',');
  const badgeSelector = prefixes.flatMap(p => [`#${p}BadgeDesktop`, `#${p}BadgeMobile`]).join(',');
  const root = document.body.dataset.famRoot || '/';
  const cartUrl = document.body.dataset.famCart || `${root}cart`;
  let activeMenu = null;
  let refresh = null;
  async function updateBadge() {
    try {
      const response = await fetch(`${root}cart.js`, { credentials: 'same-origin' });
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll(badgeSelector).forEach(el => { el.textContent = cart.item_count; });
    } catch (_) { /* Keep the server-rendered count if offline. */ }
  }
  function closeMenu(restoreFocus = true) {
    if (!activeMenu) return;
    const {button, drawer, overlay, overflow} = activeMenu;
    drawer.classList.remove('is-open');
    drawer.inert = true;
    drawer.setAttribute('aria-hidden', 'true');
    overlay?.classList.remove('is-open');
    button.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = overflow;
    activeMenu = null;
    if (restoreFocus) button.focus();
  }
  function openMenu(prefix) {
    closeMenu(false);
    const button = document.getElementById(`${prefix}Ham`);
    const drawer = document.getElementById(`${prefix}Drawer`);
    const overlay = document.getElementById(`${prefix}Overlay`);
    if (!button || !drawer) return;
    activeMenu = {button, drawer, overlay, overflow: document.body.style.overflow};
    drawer.inert = false;
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    overlay?.classList.add('is-open');
    button.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    drawer.querySelector('button, a[href]')?.focus();
  }
  async function openCart() {
    closeMenu(false);
    const drawer = document.querySelector('cart-drawer-component');
    if (!drawer || typeof drawer.open !== 'function') { location.assign(cartUrl); return; }
    drawer.open();
    await updateBadge();
  }
  // Used by the existing custom product form after a successful cart addition.
  window.famRefreshAndOpenCart = function () {
    if (refresh) return refresh;
    refresh = (async () => {
      try {
        const items = document.querySelector('cart-drawer-component cart-items-component');
        const sectionId = items?.getAttribute('data-section-id');
        if (sectionId) {
          const url = new URL(window.location.href);
          url.searchParams.set('sections', sectionId);
          const response = await fetch(url.toString(), {credentials: 'same-origin'});
          if (!response.ok) throw new Error('Cart refresh failed');
          const sections = await response.json();
          if (!sections[sectionId]) throw new Error('Cart section missing');
          const doc = new DOMParser().parseFromString(sections[sectionId], 'text/html');
          const replacement = doc.querySelector('cart-drawer-component');
          const old = document.querySelector('cart-drawer-component');
          if (!replacement || !old) throw new Error('Cart markup missing');
          old.replaceWith(replacement);
        }
        await openCart();
      } catch (_) { location.assign(cartUrl); }
      finally { refresh = null; }
    })();
    return refresh;
  };
  window.famOpenCart = openCart;
  window.famUpdateBadge = updateBadge;
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const cartLink = event.target.closest(cartSelector);
    if (cartLink) {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
      const drawer = document.querySelector('cart-drawer-component');
      if (!drawer || typeof drawer.open !== 'function') return;
      event.preventDefault();
      openCart();
      return;
    }
    for (const p of prefixes) {
      if (event.target.closest(`#${p}Ham`)) { event.preventDefault(); openMenu(p); return; }
      if (event.target.closest(`#${p}DrawerClose, #${p}Overlay`)) { closeMenu(); return; }
    }
    if (activeMenu && event.target.closest('a[href]') && activeMenu.drawer.contains(event.target)) closeMenu(false);
  });
  document.addEventListener('keydown', event => {
    if (!activeMenu) return;
    if (event.key === 'Escape') { event.preventDefault(); closeMenu(); }
    else if (event.key === 'Tab') {
      const controls = [...activeMenu.drawer.querySelectorAll('a[href], button:not([disabled])')];
      const first = controls[0], last = controls.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }
  });
  function init() {
    prefixes.forEach(p => {
      const drawer = document.getElementById(`${p}Drawer`), button = document.getElementById(`${p}Ham`);
      if (!drawer || !button || activeMenu?.drawer === drawer) return;
      drawer.inert = true;
      drawer.setAttribute('aria-hidden', 'true');
      button.setAttribute('aria-controls', drawer.id);
      button.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('shopify:section:load', () => { closeMenu(false); init(); });
  document.addEventListener('cart:update', updateBadge);
  window.addEventListener('pageshow', updateBadge);
  window.addEventListener('resize', () => { if (window.innerWidth >= 990) closeMenu(false); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { init(); updateBadge(); });
  else { init(); updateBadge(); }
})();
